import { Link } from 'react-router-dom';
import { brand, categories, credentials, enterprisePillars } from '../config/brand';
import Logo from './Logo';

export default function Footer() {
  return (
    <footer className="mt-20 border-t border-slate-100 bg-slate-50 pt-12 pb-6 text-sm text-slate-600">
      <div className="container-page grid gap-10 md:grid-cols-4">
        <div>
          <Link to="/" aria-label={`${brand.name} — home`}>
            <Logo variant="full" tone="dark" />
          </Link>
          <p className="mt-4 text-sm leading-relaxed text-slate-600">
            Institutional-strength cleaning chemistry, manufactured in India and trusted by hotels, hospitals,
            and facilities nationwide.
          </p>
          <p className="mt-3 text-xs text-slate-500">
            A unit of <span className="font-medium">{brand.legalEntity}</span>
          </p>
          <p className="mt-1 text-xs text-slate-500">Udyam Reg No: {brand.udyam}</p>
        </div>

        <div>
          <h4 className="mb-3 font-display text-sm font-semibold uppercase tracking-wide text-slate-900">
            Categories
          </h4>
          <ul className="grid grid-cols-2 gap-x-3 gap-y-1.5">
            {categories.slice(0, 10).map((c) => (
              <li key={c.slug}>
                <Link to={`/products?category=${c.slug}`} className="hover:text-brand-600">
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-3 font-display text-sm font-semibold uppercase tracking-wide text-slate-900">
            Company
          </h4>
          <ul className="space-y-1.5">
            <li><Link to="/about" className="hover:text-brand-600">About Us</Link></li>
            <li><Link to="/enterprise" className="hover:text-brand-600">Enterprise</Link></li>
            <li><Link to="/kid-safe" className="hover:text-brand-600">Kid-Safe & Baby Care</Link></li>
            <li><Link to="/distributors" className="hover:text-brand-600">Become a Distributor</Link></li>
            <li><Link to="/blog" className="hover:text-brand-600">Insights</Link></li>
            <li><Link to="/contact" className="hover:text-brand-600">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="mb-3 font-display text-sm font-semibold uppercase tracking-wide text-slate-900">
            Reach Us
          </h4>
          <address className="not-italic">
            {brand.address.line1}<br />
            {brand.address.line2}<br />
            {brand.address.city}, {brand.address.state} {brand.address.postalCode}<br />
            {brand.address.country}
          </address>
          <p className="mt-3">
            <a href={`tel:${brand.phone.replace(/\s|-/g, '')}`} className="hover:text-brand-600">
              {brand.phone}
            </a>
          </p>
          <p>
            <a href={`mailto:${brand.email}`} className="hover:text-brand-600">{brand.email}</a>
          </p>
        </div>
      </div>

      <div className="container-page mt-10 border-t border-slate-200 pt-6">
        <div className="flex flex-col gap-2 sm:flex-row sm:flex-wrap sm:items-center sm:gap-x-6">
          <span className="text-xs font-semibold uppercase tracking-wide text-slate-900">The Uclipse Standard</span>
          {enterprisePillars.map((p) => (
            <Link key={p.id} to={p.route} className="text-xs text-slate-600 hover:text-brand-600">
              {p.name}
            </Link>
          ))}
        </div>
      </div>

      <div className="container-page mt-6 border-t border-slate-200 pt-6">
        <ul className="flex flex-wrap items-center gap-x-6 gap-y-2">
          {credentials.map((c) => (
            <li key={c.label} className="flex items-center gap-1.5 text-xs font-semibold text-slate-600">
              <svg className="h-4 w-4 text-accent-green" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden>
                <path d="m5 12 5 5L20 7" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              {c.label}
            </li>
          ))}
        </ul>
      </div>

      <div className="container-page mt-6 text-xs text-slate-500">
        © {new Date().getFullYear()} {brand.legalEntity}. All rights reserved.
      </div>
    </footer>
  );
}
